import React from "react";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import CalendlyButton from "../components/CalendlyButton";


const WhoWeHelpSection = () => {
    const whoWeHelp = [
        "Busy professionals aiming to build a property investment portfolio",
        "New investors looking to start with confidence and avoid common pitfalls",
        "Those facing challenges in finding properties in competitive markets",
    ];

    return (
        <section className="bg-[#f9f9f9] py-20 px-6">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10">
                {/* Image Section */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="w-full lg:w-1/2 text-center"
                >
                    <img
                        src="/whowehelp.webp"
                        alt="Who we help"
                        className="w-full max-w-md mx-auto"
                    />
                </motion.div>

                {/* Text Section */}
                <div className="w-full lg:w-1/2 text-left">
                    <h2 className="text-3xl font-bold text-[#003366] mb-6 text-center md:text-left">Who We Help</h2>

                    <div className="space-y-4">
                        {whoWeHelp.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm border-l-4 border-[#fbb40b]"
                            >
                                <CheckCircle className="text-[#003366] mt-1 w-5 h-5" />
                                <p className="text-[#003366] text-lg leading-relaxed">{item}</p>
                            </motion.div>
                        ))}
                    </div>

                    {/* <CalendlyButton
                        label="Book Free Consultation"
                    /> */}

                </div>
            </div>
        </section>
    );
};

export default WhoWeHelpSection;